import { render, staticRenderFns } from "./CadastroPrescricaoVia.vue?vue&type=template&id=dec50ccc&"
import script from "./CadastroPrescricaoVia.vue?vue&type=script&lang=js&"
export * from "./CadastroPrescricaoVia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports